import React from 'react';
import PropTypes from 'prop-types';
import PaymentsOnHoldUploadDocModal from '../PaymentsOnHoldUploadDocModal';

const propTypes = {
  trade: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vin: PropTypes.string
  }),
  statusKey: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

const defaultProps = { trade: {}, statusKey: '' };

const PaymentsOnHoldUploadDocModalContainer = ({
  trade,
  statusKey,
  onClose
}) => {
  if (!trade) {
    return null;
  }

  return (
    <PaymentsOnHoldUploadDocModal
      trade={trade}
      statusKey={statusKey}
      onClose={onClose}
    />
  );
};

PaymentsOnHoldUploadDocModalContainer.propTypes = propTypes;
PaymentsOnHoldUploadDocModalContainer.defaultProps = defaultProps;

export default PaymentsOnHoldUploadDocModalContainer;
